import { DEFAULT_CURRENCY_CODE, ErrorHandler, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { environment } from '../environments/environment';
import { BrowserModule } from '@angular/platform-browser';
import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';


import { AuthGuard } from './core/guards/auth.guard';
import { JwtModule } from '@auth0/angular-jwt';
import * as util from '../app/core/helpers/utility';
import { ErrorService } from './core/helpers/app.error.service';
import { JwtInterceptor } from './core/guards/jwt.interceptor';
import { UnauthorizedComponent } from './account/unauthorized/unauthorized.component';
import { ToastService } from './core/helpers/toast.service';
import { NgxUiLoaderConfig, NgxUiLoaderHttpModule, NgxUiLoaderModule, NgxUiLoaderRouterModule } from "ngx-ui-loader";
import { ToastsContainer } from './core/helpers/toasts-container.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CurrencyPipe } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  fgsColor: '#000000',
  pbColor: '#000000',
  fastFadeOut: true,
};
@NgModule({
  declarations: [AppComponent, UnauthorizedComponent, ToastsContainer],
  imports: [
    NgbModule,
    HttpClientModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: util.getAuthToken,
        allowedDomains: ['localhost:5001'],
        disallowedRoutes: [],
      },
    }),
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    NgxUiLoaderHttpModule.forRoot({
      showForeground: true, exclude: [
        `${environment.baseUrl}/api/GmailClient/Mailboxes?Detailed=true`,
        `${environment.baseUrl}/api/GmailClient/Archived/Summary`,
        `${environment.baseUrl}/api/products/getProductMedia`,
      ],
      excludeRegexp: [
        ".*\\/widget\\/value\\?widgetId=.*"
      ]
    }
    ),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: ErrorHandler, useClass: ErrorService },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'USD' },
    AuthGuard,
    ToastService,
    CurrencyPipe,
    CookieService
  ],
  schemas:[
    CUSTOM_ELEMENTS_SCHEMA
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
